import React from 'react';
import { useTranslation } from 'react-i18next';

export interface ReadTimeProps {
  readTime: number;
}

const ReadTime: React.FC<ReadTimeProps> = (props) => {
  const { t } = useTranslation();

  const { readTime } = props;

  return (
    <span className="ReadTime">
      {t('components.article_metadata.read_time', { readTime })}
    </span>
  );
};

export default ReadTime;
